import { useState } from 'react'
import { useMutate } from 'restful-react'

function useResendVerificationEmail() {
    const resendVerificationEmail = useMutate({ verb: 'POST', path: '/v1/requests/account-verification' })

    const [isVerificationEmailSent, set_isVerificationEmailSent] = useState<boolean>(false)

    return {
        resendVerificationEmail,
        isVerificationEmailSent,
        set_isVerificationEmailSent,
    }
}

export default useResendVerificationEmail
